import Component from '../core/Component'
import $ from 'jquery'
import groups from '../data/catalogGroups'
import { alias } from '../data/catalogGroups'
import * as ViewportServices from '../services/Viewport'


export default class CategoriesMenu extends Component
{
    constructor($element) {
        super($element)
        this.$items = $('.products__item')
        this.$links = this.$element.find('a')
        this.$headline = $('.product-catalog__headline')

        var lang = $('html').attr('lang')

        var categories = groups

        if (lang != 'en') {
            var langAliases = alias[lang]
            Object.keys(categories).map(function(objectKey, index) {
                if (langAliases[objectKey] != objectKey) {
                    categories[langAliases[objectKey]] = categories[objectKey]
                }
            })
        }
    }

    prepare() {
        var self = this
        this.$element.on('click', 'a', function (event) {
            event.preventDefault()
            event.stopPropagation()
            var group = $(this).attr('href').replace('#', '')

            window.history.replaceState({
                "html": null,
                "pageTitle": document.title
            }, "",  $(this).attr('href'))

            ViewportServices.scrollTo($('.product-catalog').offset().top - 80)

            self.showGroup(group, $(this))
        })

        if (window.location.hash.replace('#', '') in groups) {
            $(`a[href="${window.location.hash}"]`).trigger('click')
        }
    }

    showGroup(group, $link) {
        if (group in groups) {
            this.$links.removeClass('active')
            $link.addClass('active')

            var products = this.flatten(groups[group])
            $('.product-catalog').addClass('is-hidden')

            setTimeout(() => {
                this.$headline.text($link.text())
                this.hideGroups()
                products.forEach(function (product) {
                    var $product = $(`#list-item-${product}`)

                    if ($product.length == 0) {
                        console.warn(`Product ${product} (id "list-item-${product}") does not exit`)
                    } else {
                        $product.show()
                    }
                })
                $('.product-catalog').removeClass('is-hidden')
            }, 400)
        } else {
            console.warn(`Group ${group} is not in JSON`)
        }
    }

    hideGroups() {
        this.$items.hide()
    }

    flatten(arr) {
        var self = this
        return arr.reduce(function (flat, toFlatten) {
            return flat.concat(Array.isArray(toFlatten) ? self.flatten(toFlatten) : toFlatten);
        }, []);
    }
}


// WEBPACK FOOTER //
// ./components/CategoriesMenu.js